import { createElement, Fragment, FunctionComponentElement } from "react";

import { stringify } from "../lib/utils/text";

/**
 * Replace startCase of Lodash because their function removes special chars like "%"
 */
const titleCase = (str: string): string =>
  str.replace(
    /(^| |')([a-zA-Z\u00C0-\u017F])([^ ,.:!?']*)/g,
    (p0: string, p1: string, p2: string, p3: string): string =>
      p1 + p2.toUpperCase() + p3.toLowerCase()
  );

/**
 * Converts a string or something that contains a string as provided by the external webservice (algolia, prismic, ...) into
 * a title we can display to the user.
 *
 * Note that sometimes, webservices can pass us "null" values (hence the optional input parameter), or even array of strings
 * (we will consider the first value as a default).
 */
export function toTitleCase(title?: string | string[]): string {
  // empty case
  if (!title) {
    return "";
  }

  // string array case
  if (title instanceof Array) {
    if (title.length >= 1) {
      return toTitleCase(title[0]);
    }

    return "";
  }

  // string case
  return titleCase(stringify(title, { strategy: "first" }).toLowerCase());
}

/**
 * Take a string with new line (\n) and
 * return a fragment where new line is replace by br element (<br />)
 * @param str string with \n
 */
export const convertNlToBr = (str: string): FunctionComponentElement<{}> => {
  return createElement(
    Fragment,
    {},
    ...str
      .split(/\n/g)
      .flatMap((s, i, arr) =>
        i !== arr.length - 1 ? [s, createElement("br")] : s
      )
  );
};
